import { render } from "./confirm-delete.vue?vue&type=template&id=0ab90428&lang=pug"
import script from "./confirm-delete.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm-delete.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__